import { InjectionToken } from '@angular/core';
import { EnvironmentModel } from '@okcargo-apps/shared-domain';

export const APP_CONFIG = new InjectionToken<EnvironmentModel>('Environment Configuration');
